import { IconButton, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import DateTimeFormField from '../form/fields/datetime';
import { useTranslation } from '../../contexts/TranslationContext';
import { useImmer } from 'use-immer';
import { FileMetadata } from '../../api/types/cms';
import { StopOutlined } from '@ant-design/icons';

export default function FileStartEndDate({
    file,
    onChange,
}: {
    file?: FileMetadata | null;
    onChange: (newStartEndDate: { startDate: string; endDate: string }) => void;
}) {
    const { translate } = useTranslation();
    const [values, setValues] = useImmer({
        startDate: file?.start_date ?? '',
        endDate: file?.end_date ?? '',
    });

    useEffect(() => {
        onChange(values);
    }, [values, onChange]);

    return (
        <Stack spacing={1}>
            <Stack direction="row" alignItems="center" spacing={2}>
                <DateTimeFormField
                    type="datetime"
                    name="startDate"
                    label="pages.cms.files.start_date"
                    required={false}
                    value={values.startDate}
                    onChange={newValue =>
                        setValues({ ...values, startDate: newValue })
                    }
                />
                <DateTimeFormField
                    type="datetime"
                    name="endDate"
                    label="pages.cms.files.end_date"
                    required={false}
                    value={values.endDate}
                    onChange={newValue =>
                        setValues({ ...values, endDate: newValue })
                    }
                />
                <IconButton
                    color="warning"
                    size="medium"
                    title={translate('form.general.reset')}
                    onClick={() => setValues({ startDate: '', endDate: '' })}>
                    <StopOutlined />
                </IconButton>
            </Stack>
            <Typography variant="caption" sx={{ px: 1 }}>
                {translate('pages.cms.files.dates_help')}
            </Typography>
        </Stack>
    );
}
